import   Etiquetas_Es from './Etiquetas_Es';
import   Etiquetas_En from './Etiquetas_En';
import { GnlIdiomaDefecto } from './../../Configuracion/Llaves/RepositorioConfig';

const DiccionarioEtiquetas = {
    Idiomas : {
              EN: Etiquetas_En,
              ES:Etiquetas_Es
      }, 
    IdiomaDefault: (GnlIdiomaDefecto === "EN") ? Etiquetas_En : Etiquetas_Es,
    CodIdiomaDefault: (GnlIdiomaDefecto === "EN") ? Etiquetas_En.Idioma : Etiquetas_Es.Idioma
  };
  
  export default DiccionarioEtiquetas;